import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import {
  ProductRecommendationSection,
  ProductRecommendationSource,
} from 'src/utils/analytics/trackers/internal-gtm-tracker/internal-gtm-tracker.types';
import { ProductCarousel } from 'src/components/product-carousel';
import { ProductCarousel as ProductCarouselV2 } from 'src/components/carousel-v2/types/product-carousel';
import { useSponsoredProductHandlers } from 'src/utils/ads/hooks/sponsored-products';
import { useRelatedItemsCarousel } from './use-related-items-carousel';

export type RelatedItemsCarouselProps = {
  productId: string;
  category: string;
};

export function RelatedItemsCarousel(props: RelatedItemsCarouselProps): JSX.Element | null {
  const flags = useFlags();
  const isProductCardsV2Enabled = flags['growth.ecomm.product-card-v2.rollout'] ?? false;

  const carouselProps = useRelatedItemsCarousel(props);
  const { products, loading, placement } = carouselProps;
  const label = `Related Items`;

  const { handleSponsoredProductClick, handleSponsoredProductImpression } = useSponsoredProductHandlers({
    trackerSource: ProductRecommendationSource.moloco,
    adPlacement: 'pdp.carousel',
  });

  if (!loading && !products.length) {
    return null;
  }

  if (isProductCardsV2Enabled) {
    return (
      <ProductCarouselV2
        products={products}
        isLoading={loading}
        title={label}
        onProductClick={handleSponsoredProductClick}
        onQuickAddToCart={handleSponsoredProductClick}
        onProductView={handleSponsoredProductImpression}
        placement={placement}
      />
    );
  }

  return (
    <ProductCarousel heading={label} trackerSection={ProductRecommendationSection.relatedItems} {...carouselProps} />
  );
}
